import { render } from "./Todos.vue?vue&type=template&id=ded7e9d4&scoped=true"
import script from "./Todos.vue?vue&type=script&lang=js"
export * from "./Todos.vue?vue&type=script&lang=js"

import "./Todos.vue?vue&type=style&index=0&id=ded7e9d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ded7e9d4"]])

export default __exports__